﻿export interface FirebaseConfig {
  apiKey: string;
  authDomain: string;
  projectId: string;
  storageBucket: string;
  messagingSenderId: string;
  appId: string;
  measurementId?: string;
  databaseUrl?: string;
}

// Helper to get env var with REACT_APP_ prefix support (for CRA web) or without (for functions/mobile)
const getEnv = (key: string): string | undefined => {
  return process.env[`REACT_APP_${key}`] || process.env[key];
};

const requireEnv = (key: string): string => {
  const value = getEnv(key);
  if (!value) {
    throw new Error(
      `Missing required environment variable: ${key}\n` +
      `Set REACT_APP_${key} (for web) or ${key} (for functions/mobile) in your environment.`
    );
  }
  return value;
};

export const firebaseConfig: FirebaseConfig = {
  apiKey: requireEnv('FIREBASE_API_KEY'),
  authDomain: requireEnv('FIREBASE_AUTH_DOMAIN'),
  projectId: requireEnv('FIREBASE_PROJECT_ID'),
  storageBucket: requireEnv('FIREBASE_STORAGE_BUCKET'),
  messagingSenderId: requireEnv('FIREBASE_MESSAGING_SENDER_ID'),
  appId: requireEnv('FIREBASE_APP_ID'),
  measurementId: getEnv('FIREBASE_MEASUREMENT_ID'),
  databaseUrl: requireEnv('FIREBASE_DATABASE_URL')
};

export const useEmulator = false && (process.env.NODE_ENV !== 'production') && 
                          (process.env.NODE_ENV === 'development' || 
                           getEnv('USE_FIREBASE_EMULATOR') === 'true');

export const firebaseProjectConfig = {
  emulatorPorts: {
    auth: 9099,
    firestore: 8080,
    functions: 5001,
    storage: 9199,
    ui: 4000
  },
  regions: {
    default: 'us-central1'
  }
} as const;